/**
 * サブページ用エントリ（common-sub.js）
 * common-shared.js の後に読み込む。サブ専用のみ（FAQ・PhotoSwipe等）
 */
require("./faq.js");
